import { render } from "./SilderLeftMenu.vue?vue&type=template&id=50d4f11c"
const script = {}

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__